import {
  REGEX_COMMENT_USER_MENTION,
  REGEX_MENTION,
  REGEX_NETWORK_MENTION,
} from '@kontentino/kontentino-constants/Regex';

export function stripMentionMarkup(text: string): string {
  let cleanedText = text;

  cleanedText = cleanedText.replace(
    new RegExp(REGEX_NETWORK_MENTION, 'gi'),
    (match) => {
      const nameMatch = match.match(/\[([^\]]+)\]/);
      return nameMatch ? `@${nameMatch[1]}` : match;
    },
  );

  cleanedText = cleanedText.replace(
    new RegExp(REGEX_MENTION, 'gi'),
    (match) => {
      const nameMatch = match.match(/\[([^\]]+)\]/);
      return nameMatch ? `@${nameMatch[1]}` : match;
    },
  );

  cleanedText = cleanedText.replace(
    new RegExp(REGEX_COMMENT_USER_MENTION, 'gi'),
    (match) => {
      const nameMatch = match.match(/\[([^\]]+)\]/);
      return nameMatch ? `@${nameMatch[1]}` : match;
    },
  );

  return cleanedText;
}

export function sanitizeMentionsForPlatform(
  text: string,
  targetPlatform: number,
): string {
  return stripMentionMarkup(text);
}
